/**
 * Styles for wf-progress component (Shadow DOM)
 */

import { css } from 'lit';

import { hostTokens } from '../styles/shared.styles.js';

export const wfProgressStyles = [
  hostTokens,
  css`
    :host {
      display: block;
    }

    :host([hidden]) {
      display: none;
    }

    .wf-progress {
      display: flex;
      gap: 16px;
      align-items: center;
      justify-content: center;
    }

    .wf-progress-segment {
      width: 100px;
      height: 4px;
      background-color: var(--wf-color-progress-inactive);

      border-radius: 100vw;
      transition: background-color 300ms ease;
    }

    .wf-progress-segment.completed,
    .wf-progress-segment.active {
      background-color: var(--wf-color-progress-active);
    }
  `,
];
